// src/utils/SSEListener.js
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setConnected, addMessage, clearMessages } from '../slices/sseSlice';

const SSEListener = ({ url }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!url.includes('userId=')) {
      // console.warn('No userId provided. SSE connection not initialized.');
      return; // Exit if userId is not in the URL
    }
    else {
      // console.log('SSEListener has userId', url);
    }

    dispatch(clearMessages()); // Clear messages on component mount

    const eventSource = new EventSource(url);

    eventSource.onopen = () => {
      // console.log('SSE connection opened');
      dispatch(setConnected(true));
    };

    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      // console.log('SSE onmessage:', data);
      dispatch(addMessage(data));
    };

    eventSource.onerror = () => {
      // console.error('SSE connection error');
      dispatch(setConnected(false));
      eventSource.close();
    };

    return () => {
      // console.log('Closing SSE connection');
      eventSource.close();
      dispatch(setConnected(false));
    };
  }, [dispatch, url]);

  return null;
};

export default SSEListener;
